import useElement from "backend/hooks/elements/useElement";
import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import ToolbarWithMeasureName from "components/toolbars/ToolbarWithMeasureName";
import { InitiativeCard } from "design/components/cards/InitiativeCard";
import { KPICard } from "design/components/cards/KPICard";
import KPIGridArea from "design/components/grids/MeasureGridArea";
import { InitiativesHeader, KpisHeader } from "design/components/texts/Headers";
import PageContainer from "design/layouts/PageContainer";
import SplitView from "design/layouts/SplitView";
import Page from "design/pages/Page";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";

const KPisAndInitiaivesView = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId
  );
  const { data: element, isLoading: isElementLoading } = useElement(
    ctx.elementId
  );

  const kpis = React.useMemo(() => {
    return data?.filter((item) => item.typename === "KPI") || [];
  }, [data]);
  const initiaves = React.useMemo(() => {
    return data?.filter((item) => item.typename === "Initiative") || [];
  }, [data]);

  return (
    <Page
      isLoading={
        isLoading || isPreviousData || isRefetching || isElementLoading
      }
      Toolbar={ToolbarWithMeasureName}
    >
      <PageContainer width="1400px">
        <SplitView gap="20px">
          <div>
            <KPIGridArea>
              <KpisHeader header={t("kpis.KPIs")} />
              {kpis
                ? kpis.map((el) => (
                    <KPICard
                      settings={conf.getKPIsAndInitiativesViewGaugeSettings(el)}
                      period={ctx.period || ""}
                      key={`${el.id}-${ctx.period}`}
                      element={el}
                      onSelect={() => {
                        link({ page: "kpidetails", meaId: el.id });
                      }}
                    />
                  ))
                : null}
            </KPIGridArea>
          </div>
          <div>
            <KPIGridArea>
              <InitiativesHeader header={t("initiatives.Initiatives")} />
              {initiaves
                ? initiaves.map((el) => (
                    <InitiativeCard
                      left_number_key="PLANNED_COMPLETION_prettyvalue"
                      left_number_title={t("initiatives.Planned Progress")}
                      right_number_key="VARIANCE_prettyvalue"
                      right_number_title={t("initiatives.Variance")}
                      cardTitle={t("initiatives.Actual Progress")}
                      period={ctx.period || ""}
                      key={`${el.id}-${ctx.period}`}
                      element={el}
                      translatedName={getTranslatedAttribute(
                        el,
                        "Name",
                        ctx.language
                      )}
                      onSelect={() => {
                        link({ page: "initiativedetails", meaId: el.id });
                      }}
                    />
                  ))
                : null}
            </KPIGridArea>
          </div>
        </SplitView>
      </PageContainer>
    </Page>
  );
};

export default KPisAndInitiaivesView;
